const isDev = window.location.href.indexOf('.dev.') !== -1 || window.location.href.indexOf('localhost') !== -1;
const Constants = {
  COMPANY_ID: '71392fbb-9ae5-4e45-ad2a-6511ac1ae445',
  API_BASE: 'https://api.workrails.com/beta',
  CATALOG_ID: isDev ? '544fb897-5cfd-44ed-910c-077fbdb218f6' : '2938a723-4124-4139-978d-2900237d9499',
  AUTH: '04e734df-cd33-48bb-9cfc-2cff4804a550',
  IS_DEV: isDev
}
export default Constants;
